import Icon from '../Icon';
import IconSVG from '../Icon/IconSVG';
import { media } from '../../styles/media';
import styled from 'styled-components';

export const Root = styled.div`
  margin-bottom: ${props => props.theme.layout.gutter * 2}px;
  width: 100%;
`;

export const Button = styled.button`
  border: none;
  background-color: transparent;

  position: relative;
  display: block;
  font-family: ${props => props.theme.font.medium};
  font-size: 13px;
  line-height: ${props => props.theme.layout.gutter}px;
  color: ${props => props.theme.color.grey};
  cursor: pointer;
  margin: 80px auto 0;

  ${media.tablet`
    font-size: 18px;
  `};

  &:hover {
    color: ${props => props.theme.color.blue};
  }
  transition: color 0.2s ease-in-out 0s;

  &:before {
    position: absolute;
    bottom: 20px;
    left: 50%;
    display: inline-block;
    content: '';
    width: 1px;
    height: 33px;
    background-color: ${props => props.theme.color.grey};
    transform: translate3d(-50%, -50%, 0);
    transition: transform 0.3s ease-in-out 0s;
  }
`;

export const ButtonIcon = styled.span``;

export const Content = styled.div`
  display: block;
  max-height: ${props => (props.isActive ? '1000px' : '78px')};

  font-family: ${props => props.theme.font.regular};
  font-size: 13px;
  color: ${props => props.theme.color.darkGrey};

  p {
    margin: ${props => props.theme.layout.gutter / 2}px 0;
    line-height: ${props => props.theme.layout.gutter}px;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  overflow: hidden;
  transition: all 0.5s ease 0s;

  ${media.tablet`
    font-size: 18px;
  `};
`;
